import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Icon, theme } from '@sg/garnish';

import { FlexLandingPageContent } from './FlexLandingPageContent';

export const FlexLandingPageLogo = () => {
  return (
    <FlexLandingPageContent style={styles.container}>
      <Icon name="IconFlex" color={theme.colors.CHARCOAL} width={60} height={28} />

      <View style={styles.divider} />

      <Icon
        name="IconSweetgreenFull"
        color={theme.colors.CHARCOAL}
        width={147}
        height={28}
        style={styles.sweetgreenLogo}
      />
    </FlexLandingPageContent>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    gap: theme.spacing['3'],
  },
  divider: {
    width: 1,
    height: 40,
    backgroundColor: theme.colors.CHARCOAL,
  },
  sweetgreenLogo: {
    marginTop: theme.spacing['2'],
  },
});
